<template>
    <div>
        <el-tabs v-model="activeName" type="card">
            <el-tab-pane label="报销列表" name="depmana"><Reimbus></Reimbus></el-tab-pane>
            <!-- <el-tab-pane label="全部明细" name="posmana"><Detail></Detail></el-tab-pane> -->
        </el-tabs>
    </div>
</template>

<script>
    import Reimbus from '../../components/reimbuse/reimbuse'
    import Detail from '../../components/reimbuse/detail'
    export default {
        name: "SysBasic",
        data(){
            return{
                activeName: 'depmana'
            }
        },
        components:{
            Reimbus,
            Detail
        }
    }
</script>

<style scoped>

</style>